import { Box, Text, Badge, Flex, IconButton, Skeleton } from "@chakra-ui/react";
import { BiExpand } from "react-icons/bi";

const CategoryCard = ({ category, loading }) => {
  return (
    <Skeleton isLoaded={!loading} _hover={{ size: 1.5 }}>
      <Box
        _hover={{ transform: "scale(1.1)", transitionDuration: "0.5s" }}
        borderWidth='1px'
        overflow='hidden'
        p='4'
        shadow='md'
        minWidth={250}
      >
        <Badge colorScheme='yellow'>{category.CAT_ID}</Badge>

        <Text noOfLines={1} fontSize='xl' fontWeight='semibold' mt='2'>
          {category.CAT_NAME}
        </Text>

        <Flex justify='space-between' alignItems='center' mt='2'>
          <Badge colorScheme='cyan'>{category.CAT_ABB}</Badge>
        </Flex>
        <IconButton mt='2' icon={<BiExpand size='20' />} colorScheme='cyan' />
      </Box>
    </Skeleton>
  );
};

export default CategoryCard;
